import React from 'react'
import { Modal, Icon, Button } from 'semantic-ui-react'
import { translate } from 'react-switch-lang'


const ModalTypes = ["general", "error", "warning", "danger"]

class AlertModal extends React.Component {
    // actions = [ { text:"", className:"", action:()=> {} } ]
    render() {
        const {
            open, size, type, //modal 
            header, content, //text,content
            actions, close, //action
            t, color
        } = this.props

        let modalSize = "tiny"
            // , modalHeaderIcon = null
            , modalHeaderText = t("share.system")
            , modalHeaderAction = null
            , modalActionButtons = []
            , modalContent = null

            , modalType = "general"

        if (size) {
            modalSize = size
        }

        if (header) {
            modalHeaderText = header
        }

        if (type && ModalTypes.includes(type)) {
            modalType = type
        }
        
        // if (modalType === "error") {
        //     modalHeaderIcon = <Icon name="close" color="red" />
        // } else if (modalType === "warning") {
        //     modalHeaderIcon = <Icon name="question" color="yellow" />
        // } else {
        //     modalHeaderIcon = null
        // }

        modalHeaderAction = <Icon name="close" color={color} className={`iconClose error`} onClick={close} />
        
        if (Array.isArray(actions) && actions.length > 0) {
            modalActionButtons = actions.map((btn, i) => {
                let isDisabled = false
                if (typeof btn.disabled === "boolean") {
                    isDisabled = btn.disabled
                }
                
                return <Button key={i} className={btn.className} onClick={btn.action} disabled={isDisabled}>{btn.text}</Button>
            })
        }

        if (content) {
            modalContent = content
        }

        return (
            <React.Fragment>
                <Modal
                    open={open}
                    onClose={close}
                    size={modalSize}
                    className="module alertModal"
                >
                    <Modal.Header className={`header-${modalType}`}>
                        <div className="headerBox">
                            {/* <div className="icon">
                                    {modalHeaderIcon}
                                </div> */}
                            <div className={`text ${modalType}`}>
                                <p>{modalHeaderText}</p>
                            </div>
                            <div className={`action ${modalType}`}>
                                {modalHeaderAction}
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <Modal.Description>
                            <div className="contentBox">
                                {modalContent}
                            </div>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <div className="actionBox">
                            {modalActionButtons}
                        </div>
                    </Modal.Actions>
                </Modal>
            </React.Fragment >
        )
    }
}


export default translate(AlertModal)


// WEBPACK FOOTER //
// ./src/app/components/features/share/modal/alertModal.js